<div class="menu-dialog">
    <div class="menu-dialog__header">
        <div class="menu-dialog__header-text">
            <h2 class="menu-dialog__title">Menu Card</h2>
            <p class="menu-dialog__subtitle">Select items for each meal</p>
        </div>
        <button type="button" class="menu-dialog__close" (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="menu-dialog__tabs-section">
        <div class="menu-dialog__tabs" role="tablist">
            <button type="button" class="menu-tab" *ngFor="let tab of scenarioTabs" role="tab"
                [class.menu-tab--active]="activeScenarioId === tab.scenarioId"
                [attr.aria-selected]="activeScenarioId === tab.scenarioId"
                (click)="selectScenario(tab.scenarioId)">
                <span class="menu-tab__icon-wrap">
                    <mat-icon class="menu-tab__icon">{{ tab.icon }}</mat-icon>
                </span>
                <span class="menu-tab__labels">
                    <span class="menu-tab__label-en">{{ tab.scenarioName }}</span>
                </span>
            </button>
        </div>

        <div class="menu-dialog__search-wrap">
            <mat-icon class="menu-dialog__search-icon">search</mat-icon>
            <input type="text" class="menu-dialog__search" [(ngModel)]="searchText" placeholder="Search items..."
                aria-label="Search items" />
        </div>
    </div>

    <div class="menu-dialog__body">
        <ng-container *ngIf="selectedItems.length">
            <div class="menu-section__head">
                <span class="menu-section__title">Selected Menu</span>
                <span class="menu-section__count">{{ activeScenarioSelectedCount }}</span>
            </div>

            <div class="menu-item menu-item--selected" *ngFor="let item of selectedItems" (click)="removeItem(item)">
                <div class="menu-item__thumb" *ngIf="itemImageUrl(item) as imgUrl">
                    <img [src]="imgUrl" [alt]="item.daysheetMenuItemName" (error)="onImageError($event)" />
                </div>
                <div class="menu-item__text">
                    <div class="menu-item__name-en">{{ item.daysheetMenuItemName }}</div>
                    <div class="menu-item__name-te" *ngIf="item.teluguItemName">{{ item.teluguItemName }}</div>
                </div>
                <button type="button" class="menu-item__remove"  aria-label="Remove item"
                    [disabled]="isMenuReadOnly">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </ng-container>

        <div class="menu-section__head">
            <span class="menu-section__title">Available Menu</span>
            <span class="menu-section__count">{{ availableItems.length }}</span>
        </div>

        <div class="menu-item" *ngFor="let item of availableItems" (click)="addItem(item)">
            <div class="menu-item__thumb" *ngIf="itemImageUrl(item) as imgUrl">
                <img [src]="imgUrl" [alt]="item.itemName" (error)="onImageError($event)" />
            </div>
            <div class="menu-item__text">
                <div class="menu-item__name-en">{{ item.daysheetMenuItemName }}</div>
                <div class="menu-item__name-te" *ngIf="item.teluguItemName">{{ item.teluguItemName }}</div>
            </div>
            <button type="button" class="menu-item__add"  [disabled]="isAddDisabled">+ Add</button>
        </div>

        <div class="menu-dialog__empty" *ngIf="!availableItems.length && !selectedItems.length">
            No menu items found.
        </div>
        <div class="menu-dialog__empty" *ngIf="!availableItems.length && selectedItems.length">
            All items for {{ activeScenarioName }} are selected.
        </div>
    </div>

    <div class="menu-dialog__footer">
        <div class="menu-dialog__summary">
            Total selected items: <strong>{{ totalSelectedCount }}</strong>
            <span class="menu-dialog__meal-summary" *ngIf="activeScenarioSelectedCount && activeScenarioName">
                ({{ activeScenarioSelectedCount }} in {{ activeScenarioName }})
            </span>
        </div>
        <button type="button" class="menu-dialog__submit" (click)="submit()" [disabled]="isMenuReadOnly">Submit</button>
    </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
